import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/site";

const initials = (name) =>
    name
        .split(" ")
        .map((w) => w[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();

const TestimonialCard = ({ t, index }) => (
    <motion.figure
        data-testid={`testimonial-card-${t.id}`}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay: index * 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="group flex h-full flex-col justify-between rounded-2xl border border-white/10 bg-card p-7 transition-colors duration-500 hover:border-magenta/60"
    >
        <div>
            <div className="flex items-center justify-between">
                <span className="flex gap-1" aria-label="5 de 5 estrelas">
                    {Array.from({ length: 5 }).map((_, i) => (
                        <Star key={i} className="h-3.5 w-3.5 fill-tangerine text-tangerine" />
                    ))}
                </span>
                <Quote className="h-7 w-7 text-magenta/40 transition-colors duration-500 group-hover:text-magenta" />
            </div>
            <blockquote className="mt-5 font-body text-sm italic leading-relaxed text-mist/85">
                “{t.text}”
            </blockquote>
        </div>
        <figcaption className="mt-7 flex items-center gap-3 border-t border-white/5 pt-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-magenta to-magenta-deep font-display text-sm font-bold uppercase text-white">
                {initials(t.name)}
            </span>
            <span>
                <span className="block text-sm font-semibold text-mist">{t.name}</span>
                <span className="block font-mono text-[10px] uppercase tracking-[0.2em] text-mute">
                    {t.city}
                </span>
            </span>
        </figcaption>
    </motion.figure>
);

export const Testimonials = () => (
    <section
        id="depoimentos"
        data-testid="testimonials-section"
        className="relative py-24 lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <div className="mb-14 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
                <div>
                    <motion.span
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.15 }}
                        transition={{ duration: 0.5 }}
                        className="font-mono text-[11px] uppercase tracking-[0.35em] text-tangerine"
                    >
                        // Quem já enviou conosco
                    </motion.span>
                    <motion.h2
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.15 }}
                        transition={{ duration: 0.6, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
                        className="mt-4 font-display text-4xl font-extrabold uppercase italic leading-none text-mist sm:text-6xl"
                    >
                        Depoimentos <span className="text-magenta">dos clientes</span>
                    </motion.h2>
                </div>
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.15 }}
                    transition={{ duration: 0.6, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
                    className="max-w-md text-base leading-relaxed text-mute"
                >
                    Clientes de Brasília e de todo o Brasil que confiam suas
                    cargas à Borges Cargas.
                </motion.p>
            </div>

            <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
                {TESTIMONIALS.map((t, i) => (
                    <TestimonialCard key={t.id} t={t} index={i} />
                ))}
            </div>
        </div>
    </section>
);
